import i18next from 'i18next';

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'label-ui', {
    editFolder: 'Edit folder',
    trashFolder: 'Trash folder',
    folderDeleted: 'Folder deleted',
    folderRestoreFailed: 'Could not restore the folder',
    folderRenamed: 'Folder renamed',
    empty: 'Empty',
    dropToRemove: 'Drop to remove from folder',
    removeFromLabel: 'Remove from this folder',
    moveToLabel: 'Move to folder',
    addToLabel: 'Add to folder',
    addToFavorites: 'Add to favorites',
    removeFromFavorites: 'Remove from favorites',
    itemCopied: 'Added to {{name}}',
    itemRemoved: 'Removed from {{name}}',
    itemAlreadyInLabel: 'Already in {{name}}',
    open: 'Open',
    closedAt: 'Closed at {{date}}',
    notAnalyzed: 'Not analyzed',
    analyzedAt: 'Analyzed at {{date}}',
  });
}
